<template>
  <div class="blk_info">
    <h2 class="info_title">新着情報</h2>
    <ul class="info_list">
      <li v-for="(data, idx) in newInfo">
        <p class="info_date" :class="{new : idx == 0}" v-html="data.date"></p>
        <p class="info_text" v-html="data.text"></p>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'newInfo',
  props: {
    msg: String
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState({
      newInfo: state => {
        const lists = state.siteData.home.newinfo
        if (lists.length > 5) {
          lists.length = 5
        }
        return lists
      }
    })
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.blk_info {
  width: 315px;
  margin: 0 auto 60px;
  @media screen and (max-width: 415px) {
    width: 100%;
    padding: 70px 30px 0;
  }
  .info_title {
    padding: 25px;
    color: #707070;
    font-size: 23px;
    font-family: '秀英丸ゴシック B', 'Shuei MaruGo B', '秀英丸ゴシック L', 'Shuei MaruGo L', serif;
    font-weight: normal;
    text-align: center;
    line-height: 1.0;
  }
  .info_list {
    overflow: scroll;
    max-height: 170px;
    border-top: 1px solid #BFBEBD;
    border-bottom: 1px solid #BFBEBD;
    li {
      padding: 15px 0;
      &:not(:last-child) {
        border-bottom: 1px solid #BFBEBD;
      }
    }
    .info_date {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 5px;
      color: #34787E;
      font-size: 15px;
      &.new::after {
        content: 'NEW';
        margin-left: 10px;
        padding: 1px 6px;
        color: #ffffff;
        font-size: 10px;
        background-color: #FDB309;
        border-radius: 10px;
      }
    }
    .info_text {
      font-size: 15px;
      line-height: 2.1;
      letter-spacing: 0.05em;
    }
  }
}
</style>
